import React, { useState, useEffect } from "react";
import { slide as Menu } from "react-burger-menu";
import Capsule from '../components/Capsule';
import { matias, leandro, conda, juliz, luana } from "../resources/img/index"

const MenuChat = ({ assistantConfig, handleSendButton }) => {

  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => {
    setIsOpen(false);
  };


  // Para obtener el token de google auth
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_CONDAMIND_BASE_URL) {
        return;
      }
      if (event.data.type === 'AUTH_SUCCESS') {
        const token = event.data.token;
        localStorage.setItem('google_token', JSON.stringify(token));
      }
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);

  // TODO: a futuro llevarlo a cloud storage
  const imagesMap = {
    "matias": matias,
    "leandro": leandro,
    "conda": conda,
    "juliz": juliz,
    "luana": luana,
  };

  return (
    <>
      <div className='menu-chat'>
        <div className="member-menu-container">
          <img className="member-img" alt='profile' src={imagesMap[assistantConfig.profilePicture]} />
          <h4 className='member-title'>{assistantConfig.name} {assistantConfig.lastName}</h4>
        </div>
        <div className="menu-capsules">
          {assistantConfig && assistantConfig.suggestions && assistantConfig.suggestions.map((suggestion, index) => (
            <Capsule
              handleSendButton={handleSendButton}
              shouldCloseMenu={false}
              suggestion={suggestion}
              closeMenu={closeMenu}
              key={index}
            />
          ))}
        </div>
      </div>

      <div className="menu-chat-mobile">
        <Menu right isOpen={isOpen} onStateChange={({ isOpen }) => setIsOpen(isOpen)}>
          <div>
            <div className="member-menu-container">
              <img className="member-img" alt={assistantConfig.profilePicture} src={imagesMap[assistantConfig.profilePicture]} />
              <h4 className='member-title'>{assistantConfig.name} {assistantConfig.lastName}</h4>
            </div>
            <div className="menu-capsules menu-capsules-mobile">
              {assistantConfig && assistantConfig.suggestions && assistantConfig.suggestions.map((suggestion, index) => (
                <Capsule
                  handleSendButton={handleSendButton}
                  shouldCloseMenu={true}
                  suggestion={suggestion}
                  closeMenu={closeMenu}
                  key={index}
                />
              ))}
            </div>
          </div>
        </Menu>
      </div>
    </>
  );
};

export default MenuChat;

